module.exports = __webpack_public_path__ + "media/images/suppliers/immunoreagent-f66d2ced34211f5886d870e6953a51bd.png";